export const INTERVIEW_STEPS = [
  { label: 'Round 1', stepLabel: 'Round 1 (Aptitude)', key: 'round1' },
  { label: 'Round 2', stepLabel: 'Round 2 (Manager)', key: 'round2' },
  { label: 'Round 3', stepLabel: 'Round 3 (HR)', key: 'round3' },
  { label: 'Offer Letter', stepLabel: 'Offer Letter', key: 'offerLetter' },
  { label: 'On-boarding', stepLabel: 'On-boarding Process', key: 'onboarding' },
  { label: 'Document Collection', stepLabel: 'Document Collection', key: 'documentCollection' },
  { label: 'Contract', stepLabel: 'Contract', key: 'contract' },
  { label: 'Induction', stepLabel: 'Induction', key: 'induction' },
];
